module.exports = __webpack_public_path__ + "static/media/separater.64e6aacc.png";